import { Stack } from "@mui/system";
import QuaterlyGoalFilter from "./QuaterlyGoalFilter";
import { Button } from "@mui/material";
import { useState } from "react";
import QuarterlyGoalsDrawer from "../QuarterlyGoalsDrawer/QuarterlyGoalsDrawer";
import CreateSetNewGoal from "../QuaterlyGoalModal/CreateSetNewGoal";
import { useSelector } from "react-redux";
import { selectUserData } from "../../../../../../features/userSlice";
import { CheckPermissions } from "../../../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import { setOpenModal } from "../../../../../../features/pageSpeedPerformanceSlice";
import { useDispatch } from "react-redux";

interface QuaterlyGoalFilterCardProps {
  tableData: any;
  setLoading: any;
  loading: any;
  quarterlyGoalsData: any;
  setQuarterlyGoalsData: any;
}

function QuaterlyGoalFilterCard({
  tableData,
  quarterlyGoalsData,
  setQuarterlyGoalsData,
}: QuaterlyGoalFilterCardProps) {
  const [opendrawer, setopendrawer] = useState(false);
  const userData = useSelector(selectUserData);
  const hasCreateQuarterlyGoalPermissions = CheckPermissions(
    userData?.data?.products?.assets,
    "health",
    "create_quarterly_speed_goal"
  );
  const dispatch = useDispatch();
  const handleOpen = () => {
    dispatch(setOpenModal(true));
  };

  const handleClose = () => {
    dispatch(setOpenModal(false));
  };

  const handledraweropen = () => {
    setopendrawer(true);
  };
  const handledrawerclose = () => {
    setopendrawer(false);
  };

  return (
    <>
      <Stack flexDirection={"row"} justifyContent={"space-between"}>
        <QuaterlyGoalFilter tableData={tableData} />
        <Stack flexDirection={"row"} gap={2} alignItems={"flex-end"}>
          <Button
            data-tracker="162"
            variant="outlined"
            color="secondary"
            onClick={handledraweropen}
          >
            Goals index
          </Button>
          {hasCreateQuarterlyGoalPermissions ? (
            <Button
              data-tracker="163"
              variant="contained"
              color="secondary"
              onClick={handleOpen}
            >
              Set new Goals
            </Button>
          ) : (
            <Button variant="contained" color="secondary" disabled>
              Set new Goals
            </Button>
          )}
        </Stack>
      </Stack>
      <QuarterlyGoalsDrawer open={opendrawer} handleClose={handledrawerclose} />
      <CreateSetNewGoal
        tableData={tableData}
        onCloseModal={handleClose}
        setQuarterlyGoalsData={setQuarterlyGoalsData}
        quarterlyGoalsData={quarterlyGoalsData}
      />
    </>
  );
}

export default QuaterlyGoalFilterCard;
